<template>
  <div id="remind">
    <Row>
      <Col span="21" style="display: flex">
        <Icon type="md-notifications-outline" style="font-size:18px;color:#f63"/>
        <div id="lybox">
          <ul
            id="con1"
            ref="con1"
            @click="openNoReadFun"
            :class="{anim:animate}"
            v-if="scrollAlarms.length>0"
          >
            <li v-for="(item, index) in scrollAlarms" :key="index">
              <Tag color="red" style="margin: -4px 0 0 2px">{{
                    item.info
                  }}</Tag>{{item.carNo}}
              <span style="color:#999;margin-left:10px;">
                <time-o
                  :time="item.startTime"
                  style="float: right; color: #000; margin-right: 4px"
                />
              </span>
            </li>
          </ul>
          <div v-else>暂无未读报警信息</div>
        </div>
      </Col>
      <Col span="3" style="text-align:right">
        <div @click="openNoReadFun" v-if="total>0">
          <Badge :count="total" overflow-count="999" class-name="demo-badge-alone"></Badge>
        </div>
      </Col>
    </Row>
    <Modal v-model="openNoRead" footer-hide fullscreen :title="'未读消息（'+total+'）'">
      <noRead @alrmTotal="alrmTotal" @alarms="reAlarms"></noRead>
    </Modal>
  </div>
</template>
<script>
import noRead from "./noRead";
import timeO from "../common/time.vue"
var set; //定时器
export default {
  components: {
    noRead,timeO
  },
  data() {
    return {
      animate: false,
      openNoRead: false,
      total: 0,
      scrollAlarms: []
    };
  },
  methods: {
    //报警条数
    alrmTotal(x) {
      this.total = x;
    },
    //第一条报警信息
    reAlarms(x) {
      this.scrollAlarms = x;
    },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.scrollAlarms.push(this.scrollAlarms[0]); // 将数组的第一个元素添加到数组的
        this.scrollAlarms.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 500);
    },
    openNoReadFun() {
      this.openNoRead = true;
    }
  },
  mounted() {
    
    set = setInterval(this.scroll, 3000);
  },
  watch: {
    openNoRead(val) {
      if (val) {
        clearInterval(set);
      } else {
        set = setInterval(this.scroll, 3000);
      }
    }
  }
};
</script>
<style lang="">
.demo-badge-alone {
  background: #ff3838 !important;
}
#remind{
  background:#fff;padding:15px 15px;margin:4px 0;
}

#lybox {
  height: 20px;
  overflow: hidden;
  padding-left: 8px;
  position: relative;
  margin-left: 8px;
}
#lybox::before {
  content: "";
  width: 2px;
  height: 14px;
  background: #b9b9b9;
  position: absolute;
  left: 0;
  bottom: 3px;
}
.anim {
  transition: all 0.5s;
  margin-top: -20px;
}
#con1 li {
  list-style: none;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/remind/remind.vue